import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Spinner,
  Badge,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import Whoweareservice from "../../../services/KangarooServices/Whoweareservice";
import { imageBaseApi } from "../../../utilis/imageHelper";
import toast from "react-hot-toast";
import { Triangle } from "react-loader-spinner";

const Whowearedetail = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("content");

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const fetchDetail = async () => {
    try {
      setLoading(true);
      const response = await Whoweareservice.getList();
      setDetails(response[0]);
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Failed to load details");
      setLoading(false);
      navigate("/who-we-are");
    }
  };

  useEffect(() => {
    // if () {
    fetchDetail();
    // }
  }, []);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="d-flex justify-content-center align-content-center align-items-center text-center py-5">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                  ariaLabel="triangle-loading"
                />
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }

  if (!details) {
    return (
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Who We Are Details" pageTitle="Who We Are" />
          <Card>
            <CardBody>
              <div className="text-center py-5">
                <i className="ri-file-damage-line display-1 text-muted"></i>
                <h5 className="mt-4 mb-2">No Details Found</h5>
                <Button color="primary" onClick={() => navigate("/who-we-are")}>
                  Back to List
                </Button>
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
  const handleEdit = (slug) => {
    navigate(`/who-we-are/update/${slug}`);
  };

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Who We Are"
          pageTitle="Content Management"
          // breadcrumbItems={[{ title: "Back to List", link: "/who-we-are" }]}
        />
        <div className="d-flex justify-content-end align-content-center align-items-center mb-3">
          <Button
            color="warning"
            size="md"
            // className="flex-fill"
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(details?.slug);
            }}
          >
            <i className="ri-pencil-line me-1"></i>
            Edit
          </Button>
        </div>
        <Row>
          {/* Left Column - Banner & Content */}
          <Col lg={8}>
            {/* Banner Section */}
            <Card className="mb-4 shadow-sm border">
              <CardHeader className="bg-white">
                <h5 className="mb-0 fw-semibold">
                  <i className="ri-image-line me-2 text-primary"></i>
                  Banner Information
                </h5>
              </CardHeader>
              <CardBody>
                {/* Banner Image */}
                <div className="mb-4">
                  {details.media ? (
                    <img
                      src={`${imageBaseApi}${details.media.url}`}
                      alt="Banner"
                      className="img-fluid rounded"
                      style={{
                        width: "100%",
                        maxHeight: "320px",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center bg-light rounded"
                      style={{ height: "200px" }}
                    >
                      <div className="text-center">
                        <i className="ri-image-line display-4 text-muted mb-2"></i>
                        <p className="text-muted small mb-0">No banner image</p>
                      </div>
                    </div>
                  )}
                </div>

                <Row className="g-3">
                  {/* Banner Text */}
                  <Col md={6}>
                    <div className="p-3 bg-light rounded">
                      <small className="text-muted text-uppercase fw-semibold d-block mb-2">
                        <i className="ri-text me-1"></i> Banner Text
                      </small>
                      <p className="mb-0 fw-medium">
                        {details.bannerText || "N/A"}
                      </p>
                    </div>
                  </Col>

                  {/* Banner Color */}
                  <Col md={6}>
                    <div className="p-3 bg-light rounded">
                      <small className="text-muted text-uppercase fw-semibold d-block mb-2">
                        <i className="ri-palette-line me-1"></i> Banner Color
                      </small>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded"
                          style={{
                            width: "32px",
                            height: "32px",
                            backgroundColor: details.bannerColor || "#000",
                            border: "2px solid white",
                            boxShadow: "0 0 0 1px #dee2e6",
                          }}
                        ></div>
                        <Badge color="secondary" className="px-3 py-2">
                          {details.bannerColor || "N/A"}
                        </Badge>
                      </div>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            {/* Content and Statistics Section with Tabs */}
            <Card className="shadow-sm border">
              <CardHeader className="bg-white">
                <Nav tabs className="card-header-tabs">
                  <NavItem>
                    <NavLink
                      className={activeTab === "content" ? "active" : ""}
                      onClick={() => toggle("content")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="ri-file-text-line me-2"></i>
                      Content
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={activeTab === "statistics" ? "active" : ""}
                      onClick={() => toggle("statistics")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="ri-bar-chart-box-line me-2"></i>
                      Statistics
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardHeader>
              <CardBody className="p-4">
                <TabContent activeTab={activeTab}>
                  {/* Content Tab */}
                  <TabPane tabId="content">
                    <div
                      dangerouslySetInnerHTML={{ __html: details.content }}
                      style={{ lineHeight: "1.8" }}
                    />
                  </TabPane>

                  {/* Statistics Tab */}
                  <TabPane tabId="statistics">
                    {details.subDetails && details.subDetails.length > 0 ? (
                      <Row className="g-4">
                        {details.subDetails.map((subDetail, index) => (
                          <Col lg={4} md={6} key={index}>
                            <Card className="border-0 shadow-sm h-100 overflow-hidden">
                              <CardBody className="p-0">
                                {/* Image Section with Color Accent */}
                                <div
                                  className="p-4 text-center position-relative"
                                  style={{
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  {/* Color Accent Bar */}
                                  <div
                                    className="position-absolute top-0 start-0 w-100"
                                    style={{
                                      height: "4px",
                                      backgroundColor:
                                        subDetail.color || "#5B71B9",
                                    }}
                                  ></div>

                                  {subDetail.media ? (
                                    <img
                                      src={`${imageBaseApi}${subDetail.media.url}`}
                                      alt={`Stat ${index + 1}`}
                                      className="img-fluid"
                                      style={{
                                        height: "80px",
                                        objectFit: "contain",
                                      }}
                                    />
                                  ) : (
                                    <i
                                      className="ri-bar-chart-box-line"
                                      style={{
                                        fontSize: "3rem",
                                        color: subDetail.color || "#5B71B9",
                                        opacity: 0.5,
                                      }}
                                    ></i>
                                  )}
                                </div>

                                {/* Content Section */}
                                <div className="p-4 bg-white">
                                  {/* Number */}
                                  <div className="mb-3 text-center">
                                    <h1
                                      className="fw-bold mb-0"
                                      style={{
                                        color: subDetail.color || "#5B71B9",
                                        fontSize: "2rem",
                                        lineHeight: "1",
                                      }}
                                    >
                                      {subDetail.textNumber || 0}
                                    </h1>
                                  </div>

                                  {/* Description */}
                                  <Card>
                                    <div className="text-center pb-3 ">
                                      <div
                                        className="p-2"
                                        dangerouslySetInnerHTML={{
                                          __html: subDetail.textDescription,
                                        }}
                                        style={{
                                          fontSize: "0.9rem",
                                          lineHeight: "1.5",
                                          color: "#6c757d",
                                        }}
                                      />
                                    </div>
                                  </Card>

                                  {/* Color Badge */}
                                  <div className="text-center">
                                    <span
                                      className="badge px-3 py-2"
                                      style={{
                                        backgroundColor:
                                          `${subDetail.color}15` || "#f8f9fa",
                                        color: subDetail.color || "#5B71B9",
                                        fontSize: "0.75rem",
                                        fontWeight: "600",
                                        border: `1px solid ${subDetail.color}30`,
                                      }}
                                    >
                                      {subDetail.color || "N/A"}
                                    </span>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <div className="text-center py-5">
                        <div className="mb-3">
                          <i
                            className="ri-inbox-line"
                            style={{ fontSize: "4rem", color: "#dee2e6" }}
                          ></i>
                        </div>
                        <h5 className="text-muted mb-2">
                          No Statistics Available
                        </h5>
                        <p className="text-muted small mb-0">
                          Statistics will appear here once they are added
                        </p>
                      </div>
                    )}
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>

          {/* Right Column - Sidebar */}
          <Col lg={4}>
            {/* Featured Media */}
            <Card className="mb-4 shadow-sm border">
              <CardHeader className="bg-white">
                <h5 className="mb-0 fw-semibold">
                  <i className="ri-image-2-line me-2 text-primary"></i>
                  Featured Media
                </h5>
              </CardHeader>
              <CardBody>
                {details.contentMedia ? (
                  <div>
                    <img
                      src={`${imageBaseApi}${details.contentMedia?.url}`}
                      alt="Content"
                      className="img-fluid rounded"
                      style={{
                        width: "100%",
                        maxHeight: "280px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded"
                    style={{ height: "200px" }}
                  >
                    <div className="text-center">
                      <i className="ri-image-line display-4 text-muted mb-2"></i>
                      <p className="text-muted small mb-0">
                        No media available
                      </p>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Whowearedetail;
